import React from 'react';
import { Button, Dropdown } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useLanguage } from '../hooks/useLanguage';

const LanguageSwitcher = ({ buttonClassName = '' }) => {
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage();

  const handleLanguageChange = ({ key }) => {
    changeLanguage(key);
  };

  const menuItems = availableLanguages.map((lang) => ({
    key: lang.code,
    label: (
      <span className="notranslate">
        {lang.nativeName}
        <span style={{ color: '#8c8c8c', marginLeft: 8 }}>{lang.name}</span>
      </span>
    ),
  }));

  const currentLang = availableLanguages.find((lang) => lang.code === currentLanguage);

  return (
    <Dropdown
      menu={{
        items: menuItems,
        onClick: handleLanguageChange,
        selectedKeys: [currentLanguage],
        style: { maxHeight: 360, overflowY: 'auto' },
      }}
      placement="bottomRight"
      getPopupContainer={() => document.body}
      overlayStyle={{ zIndex: 1200 }}
    >
      <Button
        type="text"
        className={`notranslate ${buttonClassName}`.trim()}
        icon={<GlobalOutlined />}
        title={currentLang ? currentLang.nativeName : 'Language'}
      />
    </Dropdown>
  );
};

export default LanguageSwitcher;
